import {Injectable, Inject} from '@angular/core';
import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';

//file reader
import { File } from 'ionic-native';
//csv parser
import * as babyparse from 'babyparse';
//storage
import { Storage } from '@ionic/storage';
//prompt alerter
import { AlertController } from 'ionic-angular';
//crypto lib
import * as cryptojs from 'crypto-js';

import {Http} from '@angular/http';

declare var cordova:any;

@Injectable()
/* DATA PROVIDER */
export class Service {

  isBrowser:any;
  http: any;

  constructor(@Inject(Storage) private dataStorage: Storage, public alertCtrl: AlertController, public plt: Platform, http: Http) {
    this.http = http;
    var platforms = this.plt.platforms();
    console.log("platform: ", platforms);

    this.isBrowser = true;

    for(var i=0; i<platforms.length; i++)
    {
      if(platforms[i] == "core" || platforms[i] == "mobileweb")  //Check for browser
        this.isBrowser = true;
    }
    console.log("platform is browser", this.isBrowser);
    console.log("vers", this.plt.versions());
  }

  isBrowserPlatform(){
    this.isBrowser = true;
    return this.isBrowser;
  }

  getLevels() {
    //Stufen 1-6
    var _levels = [];
    for(var i=1; i<=6; i++)
      _levels.push({text: "Stufe "+i.toString(), link: i, icon: "icon-ic_stufe"+i.toString()});

    return _levels;
  }

  getTopicNames() {
    var _topicNames = [
      "Organisation und Verhaltensregeln",
      "Unfallverhütung und Erste Hilfe",
      "Bekleidung, Fahrzeuge und Geräte",
      "Atem- und Körperschutz",
      "Knoten",
      "Der technische Einsatz",
      "Die taktischen Einheiten im Einsatz",
      "Dienstgrade",
      "Formalexerzieren"
    ];

    return _topicNames;
  }

  getTopics(_level: number) {
    //Namen der Themenbereiche
    var _topicNames = this.getTopicNames();

    //Icons der Themenbereiche
    var _topicIcons = [
      "clipboard",
      "medkit",
      "bus",
      "nuclear",
      "link",
      "cog",
      "apps",
      "ribbon",
      "walk"
    ];

    //topics
    var _topics = [];
    var _questMatrix = this.getQuestMatrix();
    for(var i=0; i<_topicNames.length; i++)
    {
      if(_questMatrix[_level-1][i] != 0)
        _topics.push({text: _topicNames[i], link: i+1, icon: _topicIcons[i]});
    }


    return _topics;
  }

  getQuestMatrix() {
    //Fragenmatrix für Prüfungsmodus
    var _question_matrix = [
      //Thema     Org   Unf.Verh.  FZG  ATS Knoten  Techn   Taktik    Dgr   Formalex
      /*Stufe 1*/ [5,    0,         2,   0,  4,      0,      0,        0,    0],
      /*Stufe 2*/ [6,    0,         2,   0,  4,      0,      0,        4,    1],
      /*Stufe 3*/ [5,    0,         5,   0,  4,      0,      0,        4,    1],
      /*Stufe 4*/ [5,    3,         7,   0,  4,      0,      0,        4,    1],
      /*Stufe 5*/ [6,    3,         8,   3,  4,      0,      0,        0,    0],
      /*Stufe 6*/ [0,    6,         5,   0,  4,      2,      10,       0,    0]
      ];

    return _question_matrix;
  }

  quests: any;
  fs: string;
  read: any;

  preloadQuestions() {
    var fragen = {data: null};
    var refrn = {ref: null};
    this.quests = fragen;

    refrn.ref = this;

    //preload question DATA
    console.log("is browser? ", this.isBrowser);
    if(!this.isBrowser) //is NOT Browser
    {
      this.fs =cordova.file.applicationDirectory;
      File.readAsText(this.fs, 'www/assets/data/database_questions.csv')
      .then(
      function(data){
        console.log("file success");
        //parse csv data
        var parsed = babyparse.parse(data, {delimiter: ";", header: true});
        console.log("parsed: ", parsed);
        fragen.data = parsed;
      },
      function (error) {
        console.log("error in reading file", error);
        //alert("Fehler, Fragen konnten nicht geladen werden!")<;
        refrn.ref.showPopup("Fehler", "Fragen konnten nicht geladen werden! Erneut versuchen? "+error, "Ok", "Abbrechen", refrn.ref, function(ref, button){
            if(button)
              ref.preloadQuestions();
        })
      });
    }
    else//browser
    {
      this.http.get('assets/data/database_questions.csv')
        .subscribe(data => {
          console.log("file success");
          //parse csv data
          var parsed = babyparse.parse(data._body, {delimiter: ";", header: true});
          console.log("parsed: ", parsed);
          fragen.data = parsed;
        }, error => {
          console.log("error in reading file", error);
          //alert("Fehler, Fragen konnten nicht geladen werden!")<;
          refrn.ref.showPopup("Fehler", "Fragen konnten nicht geladen werden! Erneut versuchen?", "Ok", "Abbrechen", refrn.ref, function(ref, button){
              if(button)
                ref.preloadQuestions();
          });
        });
    }
  }

  shuffle(a) {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
    return a;
  }

  getQuestions(_level: number, _topic: number, _mode: any) {
    //Fragen und Antworten
    var _quests = [];
    //console.log("get quests, level: ", _level, "topic", _topic);

    for(var i=0; i < this.quests.data.data.length; i++)
    {
      //console.log("quest ",i," stufe ", this.quests.data.data[i].stufe, " thema ", this.quests.data.data[i].thema);
      if(this.quests.data.data[i].stufe == _level && (_topic == 99 || this.quests.data.data[i].thema == _topic))
        _quests.push(this.quests.data.data[i]);
    }

    console.log("quests", _quests);

    if(_mode == "pruefen")  //random sort array
    {
      _quests = this.shuffle(_quests);
      console.log("random sort array", _quests);
    }
    return _quests;
  }

  getSettingsText() {
    var _settings = [];
    var _settingsText = [
      "Feuerwehrkommandant",
      "Gründungsjahr eigene FW",
      "Fahrzeuge eigene FW",
      "Anzahl Abschnitte im Bezirk",
      "FW im Abschnitt",
      "Bezirksfeuerwehrkommandant",
      "Bezirksjugendreferent",
      "Landesfeuerwehrjugendreferent",
      "Abschnittskommandant",
      "Landesfeuerwehrkommandant",
      "Typ. Einsätze eigene FW",
      "Druck Mittelschaumrohr",
      "Nächstes Hydr. Rettungsgerät"
    ];

    var _settingsBsp = [
      "Bsp: HBI Max Mustermann",
      "Bsp: 1890",
      "Bsp: KLF, TLF-A 4000, RF-A, KDOF",
      "Bsp: 6",
      "Bsp: 1",
      "Bsp: OBR Max Mustermann",
      "Bsp: HBI Bernd Beispiel",
      "Bsp: BR Bernd Beispiel",
      "Bsp: ABI Max Mustermann",
      "Bsp: LBD Max Mustermann",
      "Bsp: Technische Einsätze",
      "Bsp: 5  Bar",
      "Bsp: C-Stadt"
    ];

    for(var i=0; i<_settingsText.length; i++)
      _settings.push({text: _settingsText[i], bsp: _settingsBsp[i], value: null});

    return _settings;
  }

  getSettingsShort() {
    var _settingsShort = [
      "OFK",
      "Jahr",
      "Fzg",
      "AnzAbs",
      "Abschnitt",
      "BFK",
      "BFJR",
      "LFJR",
      "AFK",
      "LFK",
      "Einsatz",
      "DruckSchaum",
      "HydrRett"
    ];

    return _settingsShort;
  }

  getSettingsStd() {
    var _settingsStd = [
      "OFK",
      "Jahr",
      "Fzg",
      "AnzAbs",
      "Abschnitt",
      "BFK",
      "BFJR",
      "LFJR",
      "AFK",
      "LFK",
      "Einsatz",
      "DruckSchaum",
      "HydrRett"
    ];

    return _settingsStd;
  }

  settingsData: any = [];

  async writeStorage(_key: string, _value: string)
  {
    await this.dataStorage.set(_key, _value);
    console.log("storage write", _key, _value);
  }

  preloadSettings(){
    var _shorts = this.getSettingsShort();

    for(var i=0; i<_shorts.length; i++)
    {
      this.dataStorage.get(_shorts[i]).then((val) => {
        console.log("storage read", val);
        this.settingsData.push(val);
        });
    }
  }

  getSettingsData() {
    console.log("settings data", this.settingsData);
    return this.settingsData;
  }

  setSettingsData(_settings: any) {

    //write storage
    var _shorts = this.getSettingsShort();
    for(var i=0; i<_shorts.length; i++)
    {
      this.writeStorage(_shorts[i], _settings[i].value);
      this.settingsData[i] = _settings[i].value;
    }
  }

  getSettingsIDs()
  {
    //Returns the question ids of questions with einstellungen
    var _ids = [
      {s1: 5, s2: 0},
      {s1: 6, s2: 0},
      {s1: 12, s2: 0},
      {s1: 49, s2: 0},
      {s1: 0, s2: 49},
      {s1: 50, s2: 0},
      {s1: 51, s2: 0},
      {s1: 52, s2: 0},
      {s1: 53, s2: 0},
      {s1: 84, s2: 0},
      {s1: 138, s2: 0},
      {s1: 150, s2: 0},
      {s1: 197, s2: 0}
    ];

    return _ids;
  }

  openInBrowser(_url: string) {
    window.open(_url, '_system', 'location=yes');

    return false;
  }

  showPopup(_title: string, text: string, button1: string, button2: string, ref: any, funct: any) {
    let confirm = this.alertCtrl.create({
      title: _title,
      message: text,
      cssClass: 'alertDanger',
      buttons: [
        {
          text: button2,
          handler: () => {
            funct(ref, false);
          }
        },
        {
          text: button1,
          handler: () => {
            funct(ref, true);
          }
        }
      ]
    });
    confirm.present();
  }

  encryptText(_text: string, _pass: string)
  {
    return cryptojs.AES.encrypt(_text, _pass);
  }

  decryptText(_cipher: string, _pass: string)
  {
    var bytes  = cryptojs.AES.decrypt(_cipher, _pass);
    return bytes.toString(cryptojs.enc.Utf8);
  }
}



// WEBPACK FOOTER //
// ./src/app/service.ts